// ТОП ТУРНИРЫ (баннеры)
import React, {Component} from "react";
import Loading from "./Loading";
import Banner from "./Banner";
import $ from "jquery";
import lodash from "lodash";
import {connect} from "react-redux";
import {getBanners} from "../redux/actions/top-tourneys";

class TopTourneys extends Component {
	state = {
		isOpened : false,
	};

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		if ( this.props.topTourneys.banners.length === 0 ) {
			this.props.onGetBanners();
		}
	}

	toggleHandler() {
		$(this.refs['banners']).slideToggle(100);
		this.setState({
			isOpened : !this.state.isOpened
		});
	}

	render() {
		const {banners} = this.props.topTourneys;
		const sortedBanners = banners && lodash.sortBy(banners, i => i.order).reverse();
		const map_banners = sortedBanners.map(banner => <Banner key={`banner-${banner.id}`} item={banner}/>);

		return (
			<div className={`top-tourneys ${this.state.isOpened && 'opened'}`}>
				<div className="top-tourneys-top" onClick={this.toggleHandler.bind(this)}>
					<div className="top-tourneys__text">ТОП ТУРНИРЫ</div>
				</div>

				<div className="banners" ref="banners">
					{this.props.fetching && <Loading/>}

					{map_banners}
				</div>

				<div className="top-tourneys-bottom">
					<div className="top-tourneys__down" onClick={this.toggleHandler.bind(this)}>
						<i className={`fas fa-chevron-down ${this.state.isOpened && 'rotate'}`}></i>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		topTourneys : state.topTourneys
	}),
	dispatch => ({
		onGetBanners : () => {
			dispatch(getBanners())
		}
	})
)(TopTourneys);


// WEBPACK FOOTER //
// ./src/app/components/TopTourneys.js